export const DEVICE_TYPES = ['desktop', 'mobile'] as const
export type DeviceType = (typeof DEVICE_TYPES)[number]
